{
  "account": {
    "title": "Мій акаунт",
    "list": {
      "title": "Акаунти",
      "description": "Список рахунків прив’язаних акаунтів"
    },
    "form": {
      "name": {
        "title": "Ім’я",
        "description": "Назва вашого акаунта"
      },
      "password": {
        "title": "Пароль",
        "description": "Встановіть новий пароль для акаунта; залиште порожнім, щоб зберегти поточний"
      },
      "emailPreferences": {
        "title": "Налаштування електронної пошти",
        "description": "Оберіть типи сповіщень електронною поштою"
      }
    },
    "billing": "Реквізити для оплати",
    "subscriptions": "Підписки",
    "manageSubscription": "Керувати підпискою",
    "popup": {
      "cancel": "Ви впевнені, що хочете скасувати підписку?<br/>Ваш сайт продовжуватиме перекладатись до кінця поточного періоду підписки. Після цього переклад буде вимкнено.<br/>Будь ласка, зверніть увагу: компенсація за невикористаний період не передбачена.",
      "downgrade": "Ви впевнені, що хочете знизити тариф? Зміна набуде чинності негайно.<br/>Будь ласка, зверніть увагу: компенсація за залишок поточного платіжного циклу не передбачена.<br/>Нова ціна тарифу застосується з наступного платіжного циклу.",
      "default": "Ви впевнені, що хочете змінити свій тариф?",
      "resume": "Ви впевнені, що хочете відновити свою підписку?"
    }
  },
  "ai_translation": {
    "header": "Штучний переклад AI",
    "plan": {
      "header": "Ціни на AI-переклад",
      "used": "Ви використали {words_used} / {words_allowed} слів з AI-кредитів.",
      "remaining": "Доступні AI-кредити:",
      "words": "слів",
      "add_more_credits": "Додати AI-кредити",
      "details": {
        "idiomatic_expressions": "Ідіоматичні та технічні вирази",
        "background_translation": "Переклад у фоновому режимі",
        "best_website": "Сайти, що потребують ідеальної якості перекладу",
        "page_context": "Контекст сторінки й сайту для перекладу",
        "perfect_quality": "Ідеальна якість за доступною ціною",
        "no_recurring": "Без регулярних платежів, передоплачена квота",
        "save_40": "Економія 40% порівняно з тарифом $20",
        "save_50": "Економія 50% порівняно з тарифом $20"
      },
      "quota": "{estimated_words} слів ~ {estimated_pages} сторінок"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI-переклад",
        "intro": "Linguise презентує нову преміум-функцію — Linguise AI-переклад, що використовує LLM-моделі AI (найновіші Llama, оптимізовані для завдань перекладу). Розроблено для сайтів, що потребують бездоганної точності: враховує контекст окремої сторінки та всього сайту. Запропонуйте клієнтам найвищу якість перекладу, щоб їхнє повідомлення звучало ідеально кожною мовою.",
        "button": "Оновитись зараз"
      },
      "alert": {
        "description": "Ця функція не входить у ваш поточний тариф і потребує окремої покупки.\nАктивуйте цей додаток, щоб отримати доступ до всіх параметрів знизу."
      },
      "languages": {
        "title": "Застосувати AI-переклад до мов",
        "description": "Оберіть конкретні мови, для яких активувати AI-переклад"
      },
      "button": {
        "save": "Зберегти налаштування"
      },
      "form": {
        "advanced": {
          "title": "Розширені інструкції AI",
          "description": "Розширені інструкції AI"
        },
        "enable_mode": {
          "title": "УВІМКНУТИ AI-ПЕРЕКЛАД",
          "description": "Оберіть спосіб увімкнення AI-перекладу.\nТільки правила — застосовує наступні правила.\nТільки live-редактор — дозволяє вмикати переклад сторінка-за-сторінкою з вигляду live-редактора.\nПравила й live-редактор — використовує обидві функції.",
          "disabled": "Вимкнено",
          "rules": "Лише правила",
          "live_editor": "Лише live-редактор",
          "all": "Правила й live-редактор"
        },
        "rule_application": {
          "description": "Застосовувати AI-переклад до статичного, динамічного чи обидвох типів контенту",
          "title": "Застосувати до контенту",
          "all": "Увесь контент",
          "static": "Статичний контент",
          "dynamic": "Динамічний контент"
        },
        "website_topic": {
          "title": "Тематика сайту",
          "placeholder": "Ресторан суші...",
          "description": "Вкажіть тематику сайту для кращої якості перекладу (напр. право, ресторан суші, інтернет-магазин велозапчастин…)\nВводьте тематику англійською мовою."
        },
        "apply_to_urls": {
          "title": "Застосувати до URL",
          "description": "Оберіть конкретні URL, для яких активувати AI-переклад",
          "all_urls": "Усі URL",
          "selected_urls": "Обрані URL",
          "label": "URL для застосування",
          "placeholder": "URL для застосування",
          "wildcard": "Шаблон",
          "regex": "Регулярний вираз",
          "add": "Додати новий",
          "expression": "Тип виразу"
        },
        "apply_languages": {
          "title": "Застосувати до мов",
          "description": "Оберіть конкретні мови, для яких активувати AI-переклад",
          "all_languages": "Усі мови",
          "selected_languages": "Обрані мови",
          "placeholder": "Оберіть мови...",
          "feedback": "Необхідно обрати мову"
        },
        "formality": {
          "title": "Формальність",
          "description": "Укажіть ступінь формальності перекладу — важливо для аудиторії та контексту.\n«Нейтральна» зберігає оригінальну формальність контенту.\n«Формальна» підходить для ділового, юридичного контенту (напр. формальне ввічливе «usted» іспанською).\n«Неформальна» слушна для повсякденного спілкування (напр. «tú» іспанською).",
          "neutral": "Нейтральна",
          "formal": "Формальна",
          "informal": "Неформальна"
        },
        "sentence_structure": {
          "classic": "Класична",
          "short": "Короткі виразні речення",
          "detailed": "Деталізовані пояснювальні речення",
          "title": "Структура речень",
          "description": "Визначте бажаний стиль написання."
        },
        "content_purpose": {
          "marketing": "Маркетинг/просування (переконливий, захопливий тон)",
          "technical": "Технічна/інструкційна (ясна, точна, орієнтована на дію)",
          "support": "Підтримка клієнтів (емпатійна, корисна, заспокійлива)",
          "legal": "Юридична/відповідність (точна, формальна, однозначна)",
          "educational": "Освітня (ясна, структурована, доступна)",
          "other": "Інше (англійською)",
          "title": "Призначення контенту",
          "description": "Визначте функціональне призначення контенту, що перекладається.",
          "other_placeholder": "Опишіть призначення..."
        },
        "target_audience": {
          "title": "Цільова аудиторія",
          "description": "Визначте цільову аудиторію перекладеного контенту (англійською).",
          "placeholder": "наприклад, іспаномовні батьки, співробітники ЄС з питань конфіденційності"
        },
        "override_default_translations": {
          "title": "Переписати стандартний переклад",
          "description": "Якщо встановлено «ТАК», контент примусово перекладатиметься через AI (Linguise AI), навіть якщо вже було перекладено хмарним AI (стандартна модель)."
        },
        "force_replace_before": {
          "title": "Примусовий повторний переклад ШІ",
          "description": "Перекладіть за допомогою ШІ заново весь вміст, ШІ-переклад якого створено до вибраної дати, наприклад вміст, перекладений старішою моделлю. Повторний переклад відбудеться під час наступного відвідування відповідних сторінок згідно з правилами та використає ваші кредити ШІ.",
          "before_date": "До дати"
        },
        "model": {
          "current": "Поточний",
          "title": "Модель",
          "description": "Виберіть модель перекладу LLM, яку хочете використовувати",
          "load_error": "Не вдалося завантажити доступні моделі. Будь ласка, спробуйте пізніше.",
          "thinking_warning": "Ця модель використовує високий рівень міркування (\"мислення\") і споживатиме значно більше токенів на переклад."
        },
        "override_manual_and_selected": {
          "no_default": "Ні (за замовчуванням)",
          "title": "Перезаписувати ручні та вибрані переклади",
          "description": "За замовчуванням переклад, відредагований вручну, завжди залишається на вашому сайті, навіть після створення покращеного AI-перекладу. Встановіть «ТАК», щоб показувати покращений AI-переклад. Ваші ручні переклади зберігаються, і ви можете повернутися до них будь-коли. Це також стосується повторного перекладу сторінок для отримання нових перекладів: автоматично використовуватиметься найновіший переклад."
        }
      },
      "message": {
        "save_success": "З уже наявного перекладеного контенту приблизно {{ai_affected_urls}} сторінок буде покращено за допомогою AI-перекладу.",
        "save_success_only": "Налаштування успішно збережено."
      }
    },
    "pricing": {
      "plan": {
        "title": "Замовити квоту AI-перекладу",
        "buy_button": "КУПИТИ ПАКЕТ AI-ПЕРЕКЛАДУ"
      },
      "modal": {
        "title": "Підтвердити зміну тарифу",
        "description": "Ви впевнені, що хочете змінити свій тариф AI-перекладу?",
        "button_cancel": "Скасувати",
        "button_confirm": "Підтвердити",
        "loading": "Будь ласка, зачекайте...",
        "amount": "Сума",
        "credit": "Кредит",
        "total_due": "До сплати"
      },
      "comparison": {
        "title": "Google Cloud AI переклад\nvs Linguise AI переклад",
        "list": {
          "0": {
            "google": "Швидкі й надійні переклади",
            "linguise": "Обробка ідіоматичних і технічних виразів"
          },
          "1": {
            "google": "Миттєвий переклад усіх сторінок сайту",
            "linguise": "Генерація перекладів у фоновому режимі"
          },
          "2": {
            "google": "Найкраща якість за привабливою ціною",
            "linguise": "Ідеальна якість за доступною ціною"
          },
          "3": {
            "google": "Найкраще для великих сайтів або обмеженого бюджету",
            "linguise": "Найкраще для сайтів, що вимагають бездоганної якості перекладу"
          },
          "4": {
            "google": "Контекст сторінки для перекладу",
            "linguise": "Контекст сторінки й усього сайту для перекладу"
          }
        }
      },
      "botom_banner": {
        "title": "Випробуйте безпрецедентну точність перекладу з",
        "sub_title": "новим Linguise AI перекладом",
        "description": "Linguise покращує свої послуги автоматичного перекладу завдяки новому варіанту — Linguise AI переклад, потужному рішенню на базі передової LLM для перекладу (найновіші моделі Llama, оптимізовані під переклад). Ця опція надає розробникам сайтів і веб-студіям переклади ще вищого рівня, ідеальні для проєктів, де важлива бездоганність. Linguise AI переклад доповнює наші існуючі якісні переклади Google Cloud AI, надаючи вам більшу гнучкість і точність."
      }
    },
    "success": {
      "tab_title": "Дякуємо за придбання плану AI перекладу!",
      "title": "Дякуємо за придбання плану AI перекладу!",
      "subtitle": "Ваш план AI перекладу успішно придбано!",
      "message": "Керувати планом AI перекладу можна на сторінці налаштувань AI перекладу.",
      "home": "Керувати AI перекладом"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Ім’я",
        "description": "Назва платіжного облікового запису"
      },
      "phone": {
        "title": "Телефон",
        "description": "Телефон платіжного облікового запису"
      },
      "email": {
        "title": "Email",
        "description": "Email платіжного облікового запису"
      },
      "address": {
        "title": "Адреса",
        "description": "Адреса платіжного облікового запису",
        "city": "Місто",
        "country": "Країна",
        "address1": "Адреса 1",
        "address2": "Адреса 2",
        "postal": "Поштовий індекс",
        "state": "Область"
      },
      "tax": {
        "title": "Податковий номер"
      }
    }
  },
  "checkouts": {
    "header": "Оформлення замовлення",
    "payment_method": "Оберіть спосіб оплати",
    "stripe_card": "Кредитна картка (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Ввести нову платіжну адресу",
      "existing": "Використати існуючу адресу"
    },
    "pay_stripe": "Підтвердити й оплатити",
    "terms": "Підтверджуючи підписку, ви дозволяєте Linguise стягувати плату відповідно до наших умов. Ви можете скасувати підписку в будь-який час.",
    "coupon": {
      "title": "Є купон?",
      "placeholder": "Вставте код купона тут",
      "apply": "Застосувати",
      "percent": "Знижка {{0}}%"
    },
    "add_new": "Додати новий",
    "use_existing": "Використати існуючий спосіб оплати",
    "recurring": {
      "month_single": "Оплата щомісяця",
      "month_many": "Оплата кожні {{count}} місяців",
      "year_single": "Оплата щорічно",
      "year_many": "Оплата кожні {{count}} років",
      "day_single": "Оплата щодня",
      "day_many": "Оплата кожні {{count}} днів",
      "week_single": "Оплата щотижня",
      "week_many": "Оплата кожні {{count}} тижнів"
    },
    "add_new_no_stripe": "Додати нову картку",
    "summary": {
      "title": "Підсумок",
      "subtotal": "Проміжна сума",
      "total": "Всього"
    }
  },
  "dashboard": {
    "main": {
      "title": "Панель керування"
    },
    "statistics": {
      "main_title": "Статистика за останні 30 днів",
      "characters": "Перекладені символи",
      "words": "Перекладені слова",
      "bandwidth": "Вхідна пропускна здатність",
      "request": "Запити",
      "page_views": "Перегляди сторінок за мовами (останні 30 днів)",
      "multilingual_views": "Багатомовні перегляди сторінок (останні 30 днів)",
      "most_page_viewed": "20 найпереглядніших сторінок (останні 30 днів)",
      "no_data_yet": "Дані ще недоступні",
      "th_language": "Мова",
      "th_page_views": "Перегляди сторінок",
      "real_visitors": "Реальні відвідувачі",
      "crawler": "Вебкраулер"
    },
    "planHints": {
      "subscribeButton": "Підписатися",
      "upgradeButton": "Оновити",
      "usedWords": "Зараз використано {words_used} слів",
      "noPlan": "Для цього домену не активовано жодного плану. Підпишіться на план і розпочніть переклад сайту",
      "noPlanShopify": "Для цього домену не активовано жодного плану. Підпишіться на план у панелі Shopify і розпочніть переклад сайту",
      "trialUsage": "Зараз використано {words_used} слів з {words_allowed} доступних у пробному плані.",
      "trialEnds": "1-й місяць пробного періоду активовано до {trial_ends}.",
      "subscribeMessage": "Підпишіться до завершення, щоб переклад сайту продовжував працювати",
      "subscribeMessageShopify": "Підпишіться у панелі Shopify до завершення, щоб переклад сайту продовжував працювати",
      "trialReachedLimit": "Ви досягли максимальної кількості перекладених слів у пробному періоді.\nПідпишіться на один із планів, щоб продовжити переклад сайту.",
      "paidUsage": "У вашому плані використано {words_used} / {words_allowed} перекладених слів.",
      "paidReachedLimit": "Ви вичерпали ліміт перекладених слів у поточному плані.\nОновіть план, щоб продовжити переклад сайту.",
      "trialOfferedUsage": "Зараз використано {words_used} слів з {words_allowed} доступних у пробному плані.(Включно з {free_words} наданих слів)",
      "paidOfferedUsage": "У вашому плані використано {words_used} / {words_allowed} перекладених слів.(Включно з {free_words} наданих слів)",
      "noPlanExtra": "Зверніть увагу: неактивні домени та їхні дані регулярно автоматично видаляються.",
      "planRecommended": "На основі вашого поточного обсягу перекладу рекомендований план:",
      "planMaximumWords": "{{words}} слів",
      "notHaveTranslatedWords": "Ви ще не здійснили жодного перекладу"
    },
    "translationSetup": {
      "kicker": "НАЛАШТУВАННЯ ПІДДОМЕНУ",
      "title": "Перевірити налаштування перекладу",
      "description": "Перевірте DNS, перекладені хости, доступ до вихідного сайту та обмеження облікового запису.",
      "starting": "Перевірка...",
      "button": "Перевірити налаштування",
      "viewLatest": "Переглянути останній результат",
      "viewCurrent": "Переглянути поточну перевірку",
      "runAgain": "Перевірити ще раз",
      "viewDetails": "Показати подробиці",
      "hideDetails": "Приховати подробиці",
      "error": "Не вдалося перевірити налаштування",
      "allPassed": "Усі перевірки пройдено",
      "setupNeedsAttention": "Налаштування потребує уваги",
      "setupNeedsAttentionDescription": "Одна або кілька перевірок завершилися помилкою. Перегляньте наведені нижче пункти або зверніться до служби підтримки Linguise.",
      "lastChecked": "Остання перевірка: {{time}}",
      "domainOwnership": "Власність домену",
      "domainOwnershipDescription": "Запис підтвердження знайдено",
      "domainOwnershipFailure": "Не вдалося перевірити DNS-запис власності.",
      "translatedHosts": "Перекладені хости",
      "translatedHostsDescription": "Перевірено мовних хостів: {{count}}",
      "translatedHostsFailure": "Один або кілька мовних записів CNAME неправильні.",
      "subdomainPage": "Сторінка піддомену",
      "subdomainPageDescription": "{{count}} перекладених сторінок приймають HTTPS",
      "subdomainPageFailure": "Не вдалося встановити з’єднання TLS під час відкриття однієї або кількох перекладених сторінок.",
      "originalSite": "Вихідний сайт",
      "originalSiteDescription": "Перевірки DNS, TLS і відповіді вихідного сайту",
      "originalSiteFailure": "Перевірка DNS, TLS або відповіді вихідного сайту завершилася помилкою.",
      "documentationAdvice": {
        "dns": "Перевірити налаштування DNS",
        "tls": "Перевірити налаштування HTTPS",
        "origin": "Перевірити налаштування вихідного сайту",
        "diagnostic": "Переглянути кроки з усунення несправностей"
      },
      "evidence": {
        "originDns": "Вихідний DNS",
        "originTls": "Вихідний TLS",
        "originHttp": "Відповідь вихідного сайту",
        "observedTargets": "Виявлені цілі",
        "recordCount": "Знайдені записи",
        "addressCount": "Знайдені адреси",
        "statusCode": "Статус HTTP",
        "redirect": "Переспрямування",
        "expiresAt": "Термін дії сертифіката завершується",
        "raw": "{{key}}",
        "noValue": "Немає значення"
      },
      "checkerError": "Не вдалося завершити деякі перевірки.",
      "coreLocation": "Перевірено з {{location}}",
      "status": {
        "queued": "У черзі",
        "running": "Виконується",
        "completed": "Завершено",
        "failed": "Помилка",
        "passed": "Пройдено",
        "warning": "Попередження",
        "unknown": "Невідомо",
        "skipped": "Пропущено",
        "not_applicable": "Не застосовується"
      }
    },
    "throttling": {
      "title": "Обмеження перекладу",
      "description": "Тимчасові обмеження використання",
      "unavailable": "Тимчасові обмеження перекладу недоступні",
      "window": "{{used}} / {{max}} слів",
      "resetsIn": "Скидання через {{time}}",
      "throttled": "Переклад тимчасово призупинено",
      "throttledDescription": "Досягнуто тимчасового ліміту використання. Переклад відновиться після скидання цього періоду."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "КРОК {{step}} З {{total}}",
      "doneLabel": "ГОТОВО, МОЖЕТЕ РОЗПОЧИНАТИ ПЕРЕКЛАД!",
      "finish": {
        "title": "",
        "description": "Це ключ API для використання на вашому сайті"
      },
      "instructions": "Інструкція з встановлення",
      "domainSetting": "Налаштування домену",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP-скрипт",
        "wizardWordpressStep1": "1. Встановіть ",
        "wizardWordpressStep2": "\n 2. У налаштуваннях плагіна скопіюйте та вставте ваш ключ API\n",
        "wizardWordpressStep3": "3. Готово, можна перекладати\n\n",
        "wizardWordpressStep4": "Для детальнішої інструкції, будь ласка, перегляньте нашу документацію: ",
        "wizardJoomlaStep1": "1. Посилання на пакет Joomla: ",
        "wizardJoomlaStep2": "\n2. У налаштуваннях розширення скопіюйте та вставте ваш API-ключ",
        "wizardJoomlaStep3": "3. У конфігурації модуля встановіть мови, які потрібно відображати, і вставте модуль туди, де потрібно.",
        "wizardJoomlaStep4": "\n 4. Ви готові до перекладу\n\n",
        "wizardPhpStep1": "1. Завантажте наш PHP-скрипт тут ",
        "wizardPhpStep2": "\n2. Дотримуйтесь інструкцій з установки на нашій сторінці документації тут ",
        "wizardPhpStep3": "\n3. Додайте модуль на свої сторінки.",
        "wizardPhpStep4": "\n Скопіюйте наступний код і додайте його в head вашої HTML-сторінки — модуль перемикача відобразиться автоматично\n",
        "dispatchStep1": "Ми успішно надіслали необхідні дані до плагіна Linguise, тепер ви можете закрити це вікно.",
        "dispatchStep2": "Якщо токен зникне після закриття цього вікна, будь ласка, скопіюйте наступний токен:",
        "dispatchStep3": "Ви також можете скопіювати цей фрагмент, щоб автоматично увімкнути наш перемикач прапорців",
        "wizardOtherStep1": "Дотримуйтесь інструкцій нижче, щоб встановити Linguise на ваш домен.\n",
        "wizardOtherStep2": "Скопіюйте наступний код і додайте його в head вашої HTML-сторінки — модуль перемикача відобразиться автоматично.\n"
      },
      "trialAlreadyUsed": "Схоже, ви вже скористалися безкоштовним пробним періодом, тому вам потрібно отримати квоту перекладу\nБудь ласка, підпишіться на тариф або зв’яжіться з нами, якщо потрібно продовжити пробний період.",
      "usefulLinks": "Корисні посилання для початку роботи",
      "linkDocumentation": "Документація",
      "linkExtensionDl": "Завантаження розширення",
      "linkSubscribe": "Підписатися на тариф зараз",
      "linkDashboard": "Перейти до панелі керування",
      "exclusion": {
        "title": "Назви компаній та продуктів",
        "description": ""
      },
      "finishButton": "Завершити налаштування",
      "subdomains": "Субдомени",
      "subdomain_setup": "Налаштувати домен",
      "subdomain_auto_setup": "Підключити DNS автоматично",
      "subdomain_manual_setup": "Додати записи DNS самостійно",
      "subdomain_skip": "Зробити це пізніше",
      "auto_subdomains_info": "Вашому CMS-сайтобудівнику потрібна конфігурація DNS, щоб встановити мови для кожного субдомена (напр. es.domain.com).",
      "auto_subdomains_info_2": "Ви можете зробити це автоматично за допомогою Entri. Просто натисніть кнопку «Підключити DNS автоматично», щоб розпочати підключення до вашого менеджера DNS і додати їх через Entri.",
      "auto_subdomains_info_manual": "Або ви можете вручну налаштувати домен, натиснувши кнопку «Додати записи DNS самостійно».",
      "breadcrumbs": {
        "step1": "Крок 1: Домен, CMS та мови",
        "step2": "Крок 2: DNS мови",
        "step3": "Крок {{step}}: Інструкції з встановлення"
      }
    },
    "form": {
      "urls": {
        "dash": "Тире -",
        "underscore": "Підкреслення _",
        "title": "Переклад URL",
        "description": "Перекладати на всіх сторінках",
        "char_description": "Символ для заміни неавторизованих символів у URL",
        "advertisement_title": "⚠ Ви встановили багато мов.\n",
        "advertisement": "Ми зазвичай радимо спочатку перекладати сайт кількома мовами. Так ви зрозумієте, скільки слів на вашому сайті. Це також краще для SEO, оскільки боти Google швидше просканують усі сторінки, якщо спочатку їх менше. Через тиждень можна додати ще кілька мов і так далі."
      },
      "url": {
        "title": "URL",
        "description": "Вкажіть основний домен, починаючи з http:// або https://",
        "placeholder": "URL домену",
        "advertisement_http": {
          "title": "Ви не використовуєте протокол https",
          "description": "Будь ласка, перевірте, що ваш домен насправді не використовує протокол https, що нині рекомендовано."
        },
        "advertisement_www": {
          "title": "Ваш субдомен — не www",
          "description": "Зазвичай стандартний субдомен — www (наприклад https://www.mydomain.com). Можливо, це не ваш випадок, але перевірте, чи доданий домен правильний."
        },
        "invalid_url": {
          "line1": "Ми не змогли знайти ваш домен. Будь ласка, перевірте, що домен доступний у Інтернеті та не перенаправляється в інше місце.",
          "line2": "Якщо ви впевнені, що домен доступний, ви можете пропустити перевірку домену та натиснути кнопку «Наступний крок» знову",
          "contact": "У будь-якому випадку ви можете зв’язатися з нами за адресою",
          "force": "Пропустити перевірку домену"
        },
        "invalid_subdomain_url": "Ця URL-адреса заборонена. Субдомени повинні бути у форматі: https://www.domain.tld або https://domain.tld без підкаталогу."
      },
      "account": {
        "title": "Акаунт",
        "description": "Виберіть акаунт, щоб призначити цей домен",
        "placeholder": "Виберіть акаунт...",
        "feedback": "Потрібно вибрати акаунт"
      },
      "platform": {
        "title": "Платформа",
        "description": "Будь ласка, виберіть платформу вашого сайту за назвою CMS.",
        "learn": "Дізнатися, як вибрати",
        "placeholder": "Пошук платформи за назвою CMS...",
        "info": {
          "title": "⚠ Цю платформу нещодавно додано.\n",
          "desc": "Цей сайтобудівник підтримується Linguise, хоч і був доданий нещодавно. Якщо виникнуть проблеми, будь ласка, зв’яжіться з нами через пряму електронну пошту підтримки:"
        },
        "description_read_only": "Платформа, яку використовує ваш сайт",
        "feedback": "Потрібно вибрати платформу"
      },
      "language": {
        "title": "Мова",
        "description": "Виберіть основну мову вашого сайту",
        "placeholder": "Виберіть мову...",
        "feedback": "Потрібно вибрати мову",
        "description_read_only": "Основна мова вашого сайту"
      },
      "token": {
        "title": "API-ключ",
        "description": "Це API-ключ, який потрібно скопіювати на ваш сайт",
        "copy": "Копіювати до буфера",
        "reset": "Скинути API-ключ",
        "reset_confirm": "Будь ласка, підтвердьте скидання API-ключа"
      },
      "languages": {
        "title": "Мови перекладу",
        "description": "Виберіть мови, на які хочете перекладати ваш сайт",
        "placeholder": "Виберіть мови...",
        "feedback": "Потрібно вибрати мову"
      },
      "defaultRules": {
        "title": "Стандартні правила",
        "description": "Ми визначили набір обов’язкових правил для покращення перекладу та уникнення небажаного контенту, наприклад панелі керування WordPress.\nПізніше ви можете видалити або відредагувати ці правила за потреби."
      },
      "disallow_deletion": "Неможливо видалити домен із активною підпискою",
      "delete_confirm": "Будь ласка, підтвердьте видалення домену",
      "delete": "Видалити домен",
      "dynamic": {
        "title": "Переклад динамічного контенту",
        "description": "Динамічний контент, згенерований JavaScript і AJAX-запитами, буде перекладено (цей параметр збільшить використання перекладів)"
      },
      "partial_translations": {
        "title": "Дозволити частковий переклад",
        "description": "Якщо квоту перекладу вашого акаунта вичерпано, але сторінка все ще потребує перекладу, Linguise може продовжити відображати сторінку з уже перекладеним контентом.\nПроте деякі частини сторінки залишатимуться неперекладеними, доки ви не оновите квоту.\n\nХоча невелика кількість неперекладеного контенту зазвичай не шкодить SEO, надто багато неперекладеного контенту може негативно вплинути на досвід користувача.\nЩоб вирішити це, ви можете встановити пороговий відсоток неперекладеного контенту, дозволеного на сторінці. Якщо неперекладений контент перевищує цей поріг, користувачів автоматично перенаправлятимуть на оригінальну мовну версію сторінки.",
        "never": "Ніколи"
      },
      "translate_error_pages": {
        "title": "Переклад сторінок помилок",
        "description": "Linguise може перекладати всі сторінки помилок, проте якщо ваша сторінка помилки містить динамічний контент, як-от IP-адреса або ID запиту, варто уникати перекладу цих сторінок.",
        "not_found_page": {
          "title": "Переклад сторінки 404"
        },
        "error_page": {
          "title": "Переклад інших сторінок помилок"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Знайдено існуючий домен",
          "description": "Знайдено існуючий домен для цього користувача, ви хочете його використати?"
        }
      },
      "search_tl": {
        "title": "Пошук перекладів",
        "description": "Увімкнути пошук перекладів для вашої платформи (експериментальна функція, цей параметр збільшить використання перекладів)"
      },
      "shopify_promo": {
        "info": "Гарні новини! Тепер у нас є нативний додаток Shopify, який ви можете встановити з Shopify App Store.",
        "hyperlink": "Натисніть тут і виконайте встановлення Linguise з програми.",
        "next_btn": "Перейдіть до магазину Shopify, щоб встановити застосунок",
        "info_legacy": "Гарні новини! Тепер у нас є нативний додаток Shopify, який ви можете встановити з Shopify App Store.",
        "description_legacy": "Виберіть платформу «Shopify» замість «Shopify Legacy»"
      },
      "wix_promo": {
        "info": "Гарні новини! Тепер у нас є нативний додаток Wix, який ви можете встановити з Wix App Market.",
        "hyperlink": "Натисніть тут і виконайте встановлення Linguise з програми.",
        "next_btn": "Перейдіть до Wix App Market, щоб встановити застосунок",
        "info_legacy": "Гарні новини! Тепер у нас є нативний додаток Wix, який ви можете встановити з Wix App Market.",
        "description_legacy": "Виберіть платформу «Wix» замість «Wix Legacy»"
      },
      "ai_disallow_deletion": "Ви не можете видалити цей домен, поки доступна квота AI.\n\nБудь ласка, зверніться до нашої служби підтримки, якщо ви хочете видалити цей домен за адресою",
      "language_removal": {
        "card": {
          "title": "Видалити переклади вилучених мов",
          "description": "Ці мови вилучено з вашого сайту, але збережені переклади й надалі враховуються у квоті. Видаліть їх, щоб повернути слова.",
          "button": "Видалити переклади"
        },
        "hint": "Використані слова повернуться до вашої квоти. Це можна робити раз на {{days}} днів для кожного сайту.",
        "modal": {
          "title": "Видалити переклади?",
          "intro": "Ці переклади буде видалено назавжди:",
          "warning": "Цю дію не можна скасувати. Використані слова повернуться до вашої квоти, це може тривати кілька хвилин.",
          "limit": "Це можна робити раз на {{days}} днів для кожного сайту.",
          "confirm": "Видалити переклади"
        },
        "scheduled": "Переклади видаляються, невдовзі квота оновиться.",
        "cooldown": "Переклади цього сайту нещодавно видалено. Ви зможете видалити їх знову {{date}}.",
        "latest_completed": {
          "title": "Останнє завершене видалення",
          "description": "Перегляньте видалені мови та слова, повернуті до квоти.",
          "languages": "Видалені мови",
          "words_returned": "Слова, повернуті до квоти: {{words}}",
          "completed_at": "Завершено {{date}}"
        },
        "status": {
          "recent_title": "Нещодавнє видалення перекладів",
          "recent_description": "Стежте за останнім видаленням і дізнайтеся, коли стане доступним наступне.",
          "progress_title": "Перебіг видалення",
          "loading": "Перевіряємо перебіг видалення...",
          "unavailable": "Не вдалося завантажити перебіг видалення. Оновіть сторінку та спробуйте ще раз.",
          "label": "Стан",
          "pending": "У черзі",
          "processing": "Виконується",
          "completed": "Завершено",
          "failed": "Не вдалося",
          "unknown": "Стан недоступний",
          "percent": "Виконано на {{percent}}%",
          "current_stage": "Поточний етап: {{stage}}",
          "processed": "Оброблено записів: {{processed}}",
          "processed_total": "Оброблено {{processed}} із {{total}} записів",
          "requested_at": "Запитано {{date}}",
          "started_at": "Розпочато {{date}}",
          "completed_at": "Завершено {{date}}",
          "cooldown_period": "Це можна робити раз на {{days}} днів для кожного сайту.",
          "cooldown_blocked": "Поки що не можна розпочати інше видалення.",
          "stage": {
            "queued": "Очікування запуску",
            "processing": "Виконується",
            "refund_summary": "Обчислення повернутих слів",
            "search_translations": "Видалення перекладів пошуку",
            "url_translations": "Видалення перекладів URL",
            "translations": "Видалення перекладів",
            "completed": "Завершено",
            "failed": "Не вдалося",
            "unknown": "Виконується"
          }
        },
        "forbidden": "У вас немає дозволу на видалення перекладів."
      }
    },
    "main": {
      "edit": "Редагувати домен",
      "add": "Додати домен",
      "wizard": "Вітаємо! Майстер створення нового домену",
      "common": "Домен"
    },
    "notice": {
      "broken_card": "Ми не змогли поновити ваш тариф для {{url}} з поточним способом оплати, будь ласка, оновіть свою платіжну картку",
      "quota_reached": "Вашу квоту перекладу для {{url}} вичерпано, будь ласка, оновіть тариф, щоб відновити переклад сайту",
      "ai_no_subscription": "AI-переклад для {{url}} потребує активної підписки або активного пробного періоду. Без цього він зупиниться, будь ласка, оновіть тариф, щоб продовжити",
      "important": "Важливо",
      "quota_reached_button": "Оновіть свій план зараз",
      "broken_card_button": "Оновіть свою платіжну картку",
      "ai_no_subscription_button": "Оновіть свій план зараз",
      "quota_warning": "Ваша квота на переклад для {{url}} досягла {{throttling_used_percent}}%, її буде скинуто через {{ttl}}",
      "locked": "Домен {{url}} наразі заблоковано для міграції, ви все ще можете отримати доступ до свого сайту, але не можете редагувати чи додавати нові переклади!"
    },
    "subdomains": {
      "config_ok": "DNS піддоменів налаштовано правильно.",
      "config_invalid": "Для роботи DNS піддоменів потрібна додаткова конфігурація.",
      "config_check": "Перевіряється конфігурація DNS піддоменів, зачекайте…",
      "entri_timeout": "Entri повідомило, що час очікування розповсюдження DNS ваших піддоменів вичерпано; вам потрібно спробувати знову або зробити це вручну.",
      "entri_process": "Ваші DNS додано через Entri; зазвичай для розповсюдження потрібно 10–30 хвилин (усі мовні піддомени, як-от es.domain.com). Якщо перевірка DNS не завершиться протягом 24 годин, зверніться до нашої підтримки: support@linguise.com",
      "entri_ok": "Розповсюдження DNS триває! Очікуємо завершення…",
      "infos": "Щоб активувати перетворення, потрібно додати ці записи DNS до записів вашого домену DNS. Натисніть кнопку перевірки, коли це буде зроблено. Можливо, поширення записів DNS може зайняти деякий час, тому вам може знадобитися повернутися через кілька хвилин або годин.",
      "check": "Перевірте конфігурацію DNS"
    },
    "subscription": {
      "next_payment_amount": "Майбутні списання",
      "next_payment_date": "Дата наступного платежу",
      "invoice": {
        "header": "Історія рахунків",
        "date": "Дата",
        "amount_due": "Сума",
        "status": "Статус",
        "actions": "Дії",
        "description": "Після появи транзакцій ви можете переглянути їх тут.",
        "status_text": {
          "draft": "Чернетка",
          "failed": "Не вдалося",
          "open": "Очікується",
          "paid": "Оплачено",
          "retrying": "Повторна спроба",
          "uncollectible": "Безнадійна заборгованість",
          "void": "Анульовано"
        },
        "view": "Переглянути",
        "empty": "Для цієї підписки не знайдено жодного недавнього рахунка",
        "retry_payment": "Повторити"
      },
      "next_cancellation": "Дата скасування",
      "cancel": "Скасувати підписку",
      "change_plan": "Змінити план",
      "change": "Змінити",
      "suspend": "Призупинити платіж",
      "resume": "Відновити підписку",
      "back": "Назад",
      "save": "Зберегти",
      "confirm_resume": "Ви впевнені, що хочете відновити цю підписку?",
      "confirm_cancel": "Ви впевнені, що хочете скасувати цю підписку?",
      "confirm_header": "Ви впевнені?",
      "missing_status": "Цю підписку не знайдено",
      "not_found": "Для цього домену підписку не знайдено",
      "confirm_manual_retry": "Ви впевнені, що хочете повторити цей платіж?",
      "no_payment_method": "Невідомо",
      "remove_billing": "Видалити",
      "shopify_maneged": "Цю підписку керується Shopify; керуйте нею з панелі адміністратора Shopify.",
      "unknown_plan": "Невідомий план"
    }
  },
  "domain_listing": {
    "add": "Додати вебсайт",
    "select": "Оберіть домен"
  },
  "editable": {
    "number": "номер {{id}}"
  },
  "footer": {
    "about": "Про нас",
    "support": "Підтримка"
  },
  "frontendEditor": {
    "main": "Живий редактор",
    "description": "Живий редактор дозволяє безпосередньо редагувати переклади на вашому сайті.",
    "button": "Відкрити Живий редактор",
    "language_selection": "Вибір мови перекладу",
    "video_label": "Дізнайтеся, як користуватися живим редактором"
  },
  "general": {
    "403": {
      "tab_title": "Упс — помилка 403",
      "title": "Доступ заборонено",
      "message": "Схоже, у вас немає доступу до запитуваної сторінки.",
      "home": "Повернутися на головну"
    },
    "404": {
      "tab_title": "Упс — помилка 404",
      "title": "Сторінку не знайдено",
      "message": "Здається, ви звернули не туди. Не хвилюйтесь… таке трапляється. Ось порада, яка допоможе повернутися на правильний шлях.",
      "home": "Повернутися на головну"
    },
    "500": {
      "tab_title": "Помилка 500",
      "title": "Внутрішня помилка сервера",
      "message": "Спробуйте оновити сторінку або зв’яжіться з нами",
      "home": "Повернутися на головну"
    },
    "fields": {
      "alert": "Деякі поля заповнено некоректно; виправте помилкові поля.",
      "invalid": "Це поле некоректне",
      "phone_re": "Невірний номер телефону",
      "phone_invalid": "Невірний номер телефону",
      "email": "Поле електронної пошти недійсне"
    },
    "table": {
      "no_data": "Тут ще немає даних…"
    },
    "saving": "Зберігаємо…",
    "save": "Зберегти",
    "save_and_quit": "Зберегти й вийти",
    "invite": "Запросити",
    "cancel": "Скасувати",
    "yes": "Так",
    "no": "Ні",
    "nextStep": "Наступний крок",
    "loading": "Зачекайте, поки завантажується додаток",
    "goback": "Повернутися",
    "manage": "Керувати",
    "delete": "Видалити",
    "deleting": "Видаляємо…",
    "confirm": "Підтвердити",
    "unknown": "Невідомо",
    "hide": "Приховати",
    "show": "Показати",
    "on": "Увімкнено",
    "off": "Вимкнено",
    "default": "За замовчуванням"
  },
  "home": {
    "header": "Головна",
    "manage": "Керувати підпискою",
    "canceled": "Заплановано до скасування",
    "activate_now": "Активувати зараз",
    "activate_plan_now": "Оформити підписку",
    "upgrade_plan_now": "Оновити план зараз",
    "trial_message_part_1": "Зараз ви на пробному тарифі, ",
    "trial_message_part_2": "ви можете активувати підписку в будь-який момент.",
    "add": "Додати домен",
    "table": {
      "title": "Домени",
      "description": "Список ваших доменів; клацніть на домен, щоб керувати перекладами"
    },
    "domains": {
      "empty": "На цьому акаунті ще немає доменів"
    },
    "accountsList": {
      "title": "Акаунти",
      "add": "Додати новий акаунт",
      "name": "Назва акаунта"
    },
    "update_credit_card": "Оновити дані кредитної картки",
    "cancelling_subs": "Скасування о {{0}}",
    "resume_subscription": "Відновити підписку",
    "shopify_managed": "Керується Shopify",
    "trial_ends_at": "Закінчується о {{0}}",
    "free_trial": "Безкоштовна пробна версія",
    "no_subs": "Немає активної підписки"
  },
  "invoices": {
    "title": "Рахунки-фактури",
    "list": {
      "title": "Список рахунків-фактур"
    },
    "table": {
      "customer": "Клієнт",
      "domain": "Домен",
      "amountPaid": "Сума до сплати",
      "status": "Статус",
      "date": "Дата",
      "invoice": "Рахунок-фактура",
      "pay": "Сплатити рахунок-фактуру",
      "actions": "Дії",
      "deleted_domain": "Домен видалено",
      "plan_name": "Тариф",
      "action": "Дія"
    },
    "listPending": {
      "title": "Список очікуючих рахунків-фактур"
    }
  },
  "language_settings": {
    "display": "Відображення списку мов",
    "position": "Позиція",
    "display_help_text": "Відображати прапорець та/або назви мов. Позиція перемикача мови за замовчуванням може бути будь-де в контенті або фіксованою, яка залишається нерухомою або рухається при прокрутці",
    "side_by_side": "Поруч",
    "dropdown": "Випадаючий список",
    "popup": "Спливаюче вікно",
    "flag": "Прапорець",
    "lang_name": "Назва мови",
    "lang_short_name": "Короткі назви",
    "positions": {
      "in_place": "На місці",
      "top_left": "Зверху ліворуч",
      "top_left_no_scroll": "Зверху ліворуч (без прокрутки)",
      "top_right": "Зверху праворуч",
      "top_right_no_scroll": "Зверху праворуч (без прокрутки)",
      "bottom_left": "Знизу ліворуч",
      "bottom_left_no_scroll": "Знизу ліворуч (без прокрутки)",
      "bottom_right": "Знизу праворуч",
      "bottom_right_no_scroll": "Знизу праворуч (без прокрутки)"
    },
    "lang_names_display": {
      "title": "Відображення назв мов",
      "help_text": "У перемикачі мов відображати назви мов англійською або рідною мовою, тобто French або Français",
      "english": "Англійською",
      "native_languages": "Рідними мовами"
    },
    "flag_shape": {
      "title": "Стиль прапорців",
      "help_text": "Використовувати круглі або прямокутні svg-іконки прапорців",
      "round": "Круглі",
      "rectangular": "Прямокутні"
    },
    "english_flag_type": {
      "title": "Тип англійського прапорця",
      "help_text": "Використовувати прапор Великої Британії чи США для англійської",
      "usa": "Прапор США",
      "great_britain": "Прапор Великої Британії"
    },
    "german_flag_type": {
      "title": "Тип німецького прапорця",
      "help_text": "Використовувати прапор Австрії чи Німеччини для німецької",
      "german": "Німецький прапор",
      "austria": "Австрійський прапор"
    },
    "spain_flag_type": {
      "title": "Тип іспанського прапорця",
      "help_text": "Використовувати прапор Мексики чи Іспанії для іспанської",
      "spanish": "Іспанський прапор",
      "mexico": "Мексиканський прапор",
      "peruvian": "Перуанський прапор"
    },
    "portugal_flag_type": {
      "title": "Тип португальського прапорця",
      "help_text": "Використовувати прапор Португалії чи Бразилії для португальської",
      "portugal": "Португальський прапор",
      "brazil": "Бразильський прапор"
    },
    "taiwanese_flag_type": {
      "title": "Тип тайваньського прапорця",
      "help_text": "Використовувати тайваньський чи китайський прапор для тайваньської",
      "taiwanese": "Тайваньський прапор",
      "chinese": "Китайський прапор"
    },
    "flag_border_radius": {
      "title": "Радіус закруглення прапорців (px)",
      "help_text": "Якщо використовуєте прямокутну форму прапорців, можете задати власний радіус закруглення в пікселях"
    },
    "flag_width": {
      "title": "Розмір прапорців (px)",
      "help_text": "Виберіть розмір прапорців у пікселях. Це не змінює вагу зображення, оскільки формат — .svg"
    },
    "lang_color": {
      "color_title": "Колір назви мови",
      "color_help_text": "Виберіть стандартний колір тексту для назв мов",
      "hover_color_title": "Колір назви мови при наведенні",
      "hover_color_help_text": "Виберіть колір тексту назви мови при наведенні миші",
      "color_popup_title": "Колір мови у спливачці",
      "color_popup_help_text": "Колір назви мови у спливаючому вікні або випадаючому списку",
      "hover_color_popup_title": "Колір мови у спливачці при наведенні",
      "hover_color_popup_help_text": "Виберіть колір тексту назви мови при наведенні миші у спливаючому вікні або випадаючому списку"
    },
    "flag_box_shadow": {
      "shadow_title": "Тінь прапорця",
      "shadow_help_text": "Колір і розмір тіні для прапорців мов",
      "hover_shadow_title": "Тінь прапорця при наведенні",
      "hover_shadow_help_text": "Колір і розмір тіні для прапорців мов при наведенні миші",
      "shadow_h_offset": "Горизонтальне зміщення тіні (px)",
      "shadow_v_offset": "Вертикальне зміщення тіні (px)",
      "shadow_blur": "Розмиття тіні (px)",
      "shadow_spread": "Поширення тіні (px)",
      "shadow_color": "Колір тіні"
    },
    "order": "Порядок мов",
    "language_order_help": "Порядок мов, який відображатиметься у перемикачі. Можна перетягнути мови, щоб змінити порядок.",
    "order_reset": "Скинути порядок",
    "language_order_dragdrop": "Можна перетягнути мови, щоб змінити порядок.",
    "popup_lang_name": "Назва мови у спливачці",
    "preview": "Попередній перегляд мов"
  },
  "link": {
    "form": {
      "original": {
        "title": "Оригінальне джерело",
        "description": "Додайте оригінальне посилання й замініть його нижче за мовами, щоб перекласти",
        "srcset_description": "Ви редагуєте URL зображення. Будь ласка, перегляньте документацію, особливо якщо використовуєте srcset або не знаєте, що це",
        "link": "Посилання",
        "match_link": "Режим відповідності",
        "match_exact": "Точний",
        "match_wildcard": "Маска",
        "match_regex": "Регулярний вираз"
      },
      "alternative_languages": {
        "title": "Посилання для заміни",
        "description": "Замінюйте медіа- та зовнішні посилання на всіх сторінках за мовами…",
        "link": "Посилання для заміни"
      },
      "error": {
        "atLeastOne": "Будь ласка, додайте принаймні один переклад.",
        "url": "URL-адреса некоректна",
        "extension": "Посилання має мати розширення, але не може бути .html або .php. Також посилання не повинно містити мовного шляху, наприклад \"/fr\"",
        "regex": "Регулярний вираз некоректний",
        "wildcard": "Посилання з підстановкою має некоректний протокол"
      }
    },
    "main": {
      "parent": "Посилання",
      "edit": "Редагувати посилання"
    }
  },
  "links": {
    "title": "Керування медіа- та зовнішніми посиланнями",
    "description": "Перегляньте та відредагуйте медіа- або зовнішні посилання вашого сайту.",
    "add": "Додати посилання",
    "delete": "Видалити посилання",
    "table": {
      "original": "Оригінал",
      "language": "Мова",
      "translation": "Переклад",
      "action": "Дія",
      "delete_confirm": "Підтвердьте видалення посилання"
    }
  },
  "members": {
    "header": "Учасники",
    "invite": "Запросити нового учасника",
    "modal": {
      "inviteHeader": "Запросити нового учасника",
      "editHeader": "Редагувати учасника",
      "detachHeader": "Від’єднати учасника",
      "detachBody": "Ви впевнені, що хочете від’єднати учасника від цього акаунта?",
      "selfDetachBody": "Ви впевнені, що хочете від’єднати себе від керування цим акаунтом? Після цього ви не зможете отримати доступ до будь-яких даних, пов’язаних із цим акаунтом."
    },
    "table": {
      "title": "Список учасників",
      "description": "Ролі учасників і доступ до доменів",
      "name": "Ім’я",
      "email": "Email",
      "websites": "Вебсайти",
      "languages": "Мови",
      "role": "Роль",
      "status": "Статус",
      "resendInvite": "надіслати повторно",
      "inviteSent": "запрошення надіслано",
      "actions": "Дії",
      "edit": "Редагувати",
      "detach": "Від’єднати",
      "empty": "У вас ще немає учасників",
      "all_website": "Всі веб‑сайти та мови",
      "roles": {
        "admin": "Адмін",
        "manager": "Менеджер",
        "translator": "Перекладач"
      },
      "statuses": {
        "pending": "Очікує",
        "accepted": "Прийнято",
        "declined": "Відхилено"
      }
    },
    "errors": {
      "role": "Ви маєте вибрати роль",
      "domains": "Для вибраної ролі потрібно вибрати принаймні 1 вебсайт",
      "languages": "Для вибраних вебсайтів потрібно вибрати принаймні 1 мову"
    },
    "inviteSent": "Ваше запрошення успішно надіслано"
  },
  "pagination": {
    "showing": "Показано {{limit}} із {{total}} результатів",
    "showing_only_count": "Показано {{limit}} результатів"
  },
  "payments_method": {
    "header": "Способи оплати",
    "table": {
      "title": "Список способів оплати",
      "description": "Під’єднані до вашого акаунта способи оплати",
      "default": "За замовчуванням",
      "action_edit_remove": "Редагувати чи видалити",
      "action_remove": "Видалити",
      "action_default": "Зробити основним",
      "action_fallback": "Зробити резервним",
      "expires": "Діє до",
      "add_new_card": "Додати спосіб оплати",
      "action_fallback_remove": "Видалити з резерву",
      "fallback": "Резервний",
      "action_edit": "Редагувати",
      "action_delete": "Видалити",
      "action_default_remove": "Прибрати як основний",
      "domain_count@@one": "Використовується {{count}} доменами",
      "domain_count@@other": "Використовується {{count}} доменами"
    },
    "paypal_bind": {
      "button": "Під’єднати акаунт PayPal",
      "button_load": "Під’єднання…",
      "disconnected": "Не під’єднано",
      "success": "Ваш акаунт PayPal тепер під’єднано, з наступного рахунка буде знято 5 $!",
      "success_no_promo": "Ваш акаунт PayPal тепер під’єднано",
      "error": "Сталася помилка",
      "success_header": "Успішно"
    },
    "card_add": {
      "header": "Додати нову картку",
      "success": "Нову картку під’єднано до Linguise!",
      "terms": "Надаючи дані вашої картки, ви дозволяєте Linguise стягувати кошти з неї за майбутні платежі відповідно до наших умов обслуговування."
    },
    "card_detail": {
      "header": "Інфо про картку",
      "delete": {
        "error": "Ви не можете видалити цей спосіб оплати, оскільки він має активні підписки!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Підписки на цьому способі оплати",
        "header_domain": "Домен",
        "header_plan": "План",
        "header_status": "Статус",
        "header_actions": "Дії",
        "cancelling": "Скасування: {{0}}",
        "next_payment": "Наступний платіж: {{0}}",
        "action_renew": "Поновити",
        "no_subs_header": "Немає підписок для показу",
        "no_subs_desc": "Як тільки буде оформлено підписку на цю картку, тут з’явиться вся інформація",
        "action_manage": "Керувати"
      },
      "status": {
        "active": "Активна",
        "canceled": "Скасовано",
        "incomplete": "Неоплачено",
        "incomplete_expired": "Неоплачено (термін дії минув)",
        "missing": "Помилка",
        "past_due": "Протерміновано",
        "trialing": "Тестовий період",
        "unpaid": "Неоплачено"
      }
    },
    "delete_confirm_body": "Ви впевнені, що хочете видалити цей спосіб оплати? Цю дію неможливо скасувати!",
    "delete_confirm_header": "Видалити спосіб оплати?",
    "card_edit": {
      "header": "Редагувати картку",
      "billing_header": "Платіжна інформація",
      "address_error": "Адреса є обов’язковою!",
      "card_number": "Номер картки",
      "card_expiry": "Термін дії",
      "expiry_error_month": "Надано некоректний місяць",
      "expiry_error_year": "Надано некоректний рік",
      "expiry_error_expired": "Термін дії вашої картки минув.",
      "card_header": "Інформація про картку",
      "expiry_error_empty": "Це поле обов’язкове!"
    }
  },
  "plans": {
    "per": "за",
    "wordsTranslated": "перекладених слів",
    "current": "Поточний",
    "archived": "Архівовано",
    "day": "день",
    "week": "тиждень",
    "month": "місяць",
    "year": "рік",
    "activate": "Активувати",
    "cancel": "Скасувати",
    "change": "Змінити",
    "upgrade": "Оновити",
    "downgrade": "Понизити",
    "resume": "Відновити",
    "notEnoughWords": "Недостатньо слів",
    "yearIntervalOnly": "Неможливо перейти з річного плану",
    "subsCanceled": "Вже триває скасування іншої підписки",
    "wordsUnlimited": "Необмежено слів",
    "tabs": {
      "day": "Щоденні ціни",
      "week": "Тижневі ціни",
      "month": "Щомісячні ціни",
      "year": "Річні ціни",
      "sub_texts": {
        "day": "Одна фіксована ціна щодня",
        "week": "Одна фіксована ціна кожного тижня",
        "month": "Одна фіксована ціна щомісяця",
        "year": "Один місяць безкоштовно, один рахунок на рік"
      }
    },
    "details": {
      "new_languages": "Додавайте нові мови в будь-який час",
      "one_month_trial": "Безкоштовний місячний пробний період для кожного нового сайту",
      "multi_content_indexed": "100% багатомовного контенту індексується",
      "translate_new_content": "Миттєво перекладайте новий контент",
      "free_installation": "Безкоштовне встановлення та налаштування",
      "compared_monthly_plan": "Один місяць безкоштовно порівняно з місячними планами",
      "risk_free_recurring": "Безпечне автоматичне поновлення платежу при збої",
      "unlimited_languages": "Необмежені мови та перегляди сторінок",
      "high_server_resources": "Високі серверні ресурси",
      "billed": {
        "day": "Щоденне оплата",
        "week": "Щотижнева оплата",
        "month": "Щомісячна оплата",
        "year": "Щорічна оплата"
      },
      "request_max_size": "Максимальний розмір запиту: {{0}}"
    },
    "frequent_question": {
      "title": "Часті питання",
      "questions": {
        "trial": {
          "question": "Чи можу я скористатися пробним періодом на новому домені сайту?",
          "answer": "Так, ми надаємо 30-денний безкоштовний пробний період для кожного нового домену, який ви додаєте до свого акаунта. Це дозволяє повноцінно протестувати послугу перекладу на новому сайті."
        },
        "seo": {
          "question": "За скільки часу покращиться мій SEO?",
          "answer": "Контент, зокрема багатомовний, потребує часу для повного індексування та хорошого ранжування. Залежно від трафіку та розміру сайту це займає від 3 до 6 тижнів."
        },
        "quota": {
          "question": "Чи входять переклади людини до ліміту?",
          "answer": "Ні, ліміт слів стосується лише автоматичного машинного перекладу. Перекладач може вручну редагувати автоматичні переклади без обмежень."
        }
      }
    },
    "best_offer": "Найкраща пропозиція",
    "period": {
      "days@@one": "день",
      "days@@other": "{{count}} днів",
      "hours@@one": "година",
      "hours@@other": "{{count}} годин",
      "minutes@@one": "хвилина",
      "minutes@@other": "{{count}} хвилин",
      "seconds@@one": "секунда",
      "seconds@@other": "{{count}} секунд"
    },
    "words": {
      "billion": "{{value}} млрд",
      "million": "{{value}} млн",
      "thousand": "{{value}} тис"
    },
    "throttling_info": "{{words}} слів за {{period}}"
  },
  "profile": {
    "welcome": "Ласкаво просимо!",
    "account": "Мій акаунт",
    "subscriptions": "Підписки",
    "logout": "Вийти"
  },
  "register": {
    "errors": {
      "password": "Мінімум 8 символів, будь-які символи"
    }
  },
  "route": {
    "dashboard": "Панель керування",
    "rules": "Правила",
    "translations": "Переклади",
    "search_translations": "Пошукові запити",
    "urls_translations": "Переклади URL",
    "links": "Медіа та зовнішні посилання",
    "online_editor": "Живий редактор",
    "settings": "Налаштування",
    "domain": {
      "finish": "Налаштування",
      "preconfig": "Налаштування"
    },
    "home": "Головна",
    "domain_list": "Список доменів",
    "members": "Учасники",
    "invoices": "Рахунки",
    "billing": "Реквізити для оплати",
    "language_display": "Відображення мовних прапорців",
    "payment_methods": "Способи оплати",
    "ai_translation": "AI-переклад",
    "ai_translation_settings": "Налаштування",
    "ai_translation_pricing": "Ціноутворення"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Текст для ігнорування",
        "add": "Додати новий",
        "title": "Текст для ігнорування",
        "description": "Додайте один або кілька текстів, які слід ігнорувати",
        "ignore_case": "Ігнорувати регістр"
      },
      "html_content": {
        "title": "Застосувати до HTML-вмісту",
        "description": "Застосувати правило до всього вмісту або вибрати конкретний CSS-селектор",
        "all_page": "Уся сторінка",
        "css_selector": "CSS-селектор",
        "label": "CSS-селектор",
        "placeholder": "Селектор для застосування",
        "add": "Додати нове"
      },
      "apply_to_urls": {
        "title": "Застосувати до URL-адрес",
        "description": "Виберіть конкретні URL-адреси, до яких має застосовуватися правило",
        "all_urls": "Усі URL-адреси",
        "selected_urls": "Вибрані URL-адреси",
        "label": "URL-адреса для застосування",
        "placeholder": "URL-адреса для застосування",
        "original_url": "Оригінальні URL-адреси",
        "translated_url": "Перекладена URL-адреса",
        "wildcard": "Маска",
        "regex": "Регулярний вираз",
        "add": "Додати нове",
        "expression": "Тип виразу"
      },
      "apply_urls": {
        "title_exclude": "Виключити з URL-адрес",
        "title_replace": "Замінити в URL-адресах",
        "title_description": "Також застосовувати це правило до перекладу URL-адрес"
      },
      "apply_languages": {
        "title": "Застосувати до мов",
        "description": "Виберіть конкретні мови, до яких має застосовуватися правило",
        "all_languages": "Усі мови",
        "selected_languages": "Вибрані мови",
        "placeholder": "Виберіть мови…",
        "feedback": "Потрібно вибрати мову"
      },
      "name": {
        "title": "Назва",
        "description": "Дайте правилу назву для зручності",
        "placeholder": "Назва правила"
      },
      "type": {
        "title": "Тип",
        "description": "Виберіть тип правила, яке хочете додати",
        "text_ignore": "Ігнорування тексту",
        "text_replace": "Заміна тексту",
        "content_exclusion": "Виключення вмісту",
        "url_exclusion": "Виключення за URL",
        "ignore_inline": "Ігнорувати вбудоване",
        "full_description": {
          "text_ignore": "Додайте правила, щоб уникнути перекладу певного тексту. Це може бути назва продукту, бренду чи інші технічні елементи, які не потрібно перекладати.",
          "text_replace": "Заміна тексту дозволяє замінити певний текст на потрібний переклад; це може знадобитися, коли переклад втрачає контекст.",
          "content_exclusion": "Виключення вмісту допоможе уникнути перекладу певного вмісту на сторінці.\n Якщо ви хочете повністю виключити сторінку з перекладу (без багатомовної URL-адреси та перекладеного вмісту), використовуйте тип «Виключення за URL».",
          "url_exclusion": "Виключення сторінки з перекладу допоможе вказати сторінки, які не потрібно перекладати.",
          "ignore_inline": "Уникати перекладу певного вбудованого вмісту; натомість перекладати кожен тег окремо."
        }
      },
      "text_replace": {
        "title": "Текст для заміни",
        "description": "Замініть певний текст на потрібний переклад. Замінюйте будь-який текст на всіх сторінках, по мовах…",
        "text_to_replace": "Текст для заміни",
        "ignore_case": "Ігнорувати регістр",
        "text_type": "Заміна в перекладі",
        "text_type_original": "Оригінал",
        "text_type_translation": "Переклад",
        "keep_case": "Намагатися зберегти регістр",
        "add": "Додати нове"
      },
      "content_exclusion": {
        "title": "Виключення вмісту",
        "description": "Виберіть один або кілька CSS-селекторів, які не перекладатимуться",
        "label": "CSS-селектор",
        "placeholder": "Селектор для застосування",
        "add": "Додати нове"
      },
      "multilingual_url": {
        "title": "Використовувати багатомовну URL-адресу",
        "description": "Якщо встановлено «Так», URL-адреса НЕ перекладатиметься, але сторінка залишиться багатомовною з перекладеним вмістом",
        "live_example_title": "Живий приклад",
        "live_example_description": "Вихідна URL-адреса: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Згенерована URL-адреса: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Згенерована URL-адреса: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Застосувати правило до статичного чи динамічного вмісту, або до обох",
        "title": "Застосувати до вмісту",
        "all": "Увесь вміст",
        "static": "Статичний вміст",
        "dynamic": "Динамічний вміст"
      },
      "force_apply_urls": {
        "title_description": "Примусово застосувати це правило до всіх перекладів URL-адрес, включаючи наявні!",
        "title_replace": "Примусова заміна в URL-адресах",
        "title_exclude": "Примусове виключення з URL-адрес",
        "warning": "Попередження",
        "warning_part1": "Увімкнення «Так» може пошкодити переклади URL-адрес вашого сайту.",
        "warning_part2": "Це може тимчасово або назавжди створити сторінку 404; продовжуйте лише, якщо розумієте наслідки.",
        "warning_replacement_original": "Додаткове попередження: ви намагаєтеся замінити оригінальний вміст, який може вплинути на URL-адресу; переклад може зазнати невдачі, оскільки Linguise не зможе правильно знайти оригінальні URL-адреси."
      }
    },
    "main": {
      "parent": "Правила",
      "edit": "Редагувати правило",
      "add": "Нове правило"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "«{{text_ignore}}» ігноруватиметься у вмісті та в URL-адресі",
      "preview_single": "«{{text_ignore}}» ігноруватиметься у вмісті",
      "preview_more_with_url": "«{{text_ignore}}» і ще {{count}} ігноруватимуться у вмісті",
      "preview_more": "«{{text_ignore}}» і ще {{count}} ігноруватимуться у вмісті",
      "other_parameters": "Для цього правила встановлено інші параметри; натисніть кнопку редагування, щоб дізнатися більше"
    },
    "text_replace": {
      "preview_single_with_url": "«{{original}}» замінюється на «{{replacement}}» у вмісті та в URL-адресах",
      "preview_single": "«{{original}}» замінюється на «{{replacement}}» у вмісті",
      "preview_more_with_url": "«{{original}}» замінюється на «{{replacement}}» у вмісті та в URL-адресах, і ще {{nb}}",
      "preview_more": "«{{original}}» замінюється на «{{replacement}}» у вмісті, і ще {{nb}}",
      "other_parameters": "Для цього правила встановлено інші параметри; натисніть кнопку редагування, щоб дізнатися більше"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS-селектор(ів) виключено з перекладу",
      "other_parameters": "Для цього правила встановлено інші параметри; натисніть кнопку редагування, щоб дізнатися більше"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL-адрес виключено з перекладу, але зберігається багатомовний префікс",
      "some": "{{nb}} URL-адрес повністю виключено з перекладу",
      "all_multilingual": "усі URL-адреси виключено з перекладу, але зберігається багатомовний префікс",
      "all": "усі URL-адреси повністю виключено з перекладу",
      "other_parameters": "Для цього правила встановлено інші параметри; натисніть кнопку редагування, щоб дізнатися більше"
    },
    "ignore_inline": {
      "elements": "Увесь вбудований вміст перекладатиметься як блочний на сторінці",
      "all_elements": "Частину вбудованого вмісту перекладатиметься як блочний на сторінці",
      "other_parameters": "Для цього правила встановлено інші параметри, натисніть кнопку редагування, щоб отримати більше інформації"
    },
    "title": "Керування правилами",
    "description": "Керуйте виключеннями та замінами перекладів на всьому сайті",
    "add": "Додати нове правило",
    "table": {
      "title": "Назва",
      "no_data": "Ще немає правил",
      "type": "Тип",
      "preview": "Попередній перегляд правила",
      "action": "Дія",
      "delete_confirm": "Підтвердьте видалення правила",
      "types": {
        "text_ignore": "Ігнорувати текст",
        "text_replace": "Замінити текст",
        "content_exclusion": "Виключення вмісту",
        "url_exclusion": "Виключення URL",
        "ignore_inline": "Ігнорувати вбудоване",
        "unknown": "Невідоме правило"
      }
    },
    "apply_on_content": {
      "static": "Це правило застосовуватиметься лише до статичного контенту",
      "dynamic": "Це правило застосовуватиметься лише до динамічного контенту"
    }
  },
  "search_translations": {
    "title": "Керування пошуковими запитами",
    "description": "Список усіх перекладів вашого сайту, що використовуються через пошукові форми (із перекладеної мови на основну мову домену)",
    "filter_languages": "Фільтрувати за мовами...",
    "filter_original": "Фільтрувати за текстом оригіналу",
    "filter_translation": "Фільтрувати за перекладеним текстом",
    "table": {
      "original": "Оригінал",
      "language": "Мова",
      "translation": "Переклад"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Не вдалося оформити підписку!",
      "title": "Не вдалося оформити підписку!",
      "subtitle": "Під час обробки підписки сталася помилка.",
      "home": "Повернутися на головну",
      "generic": "Сталася невідома помилка з боку Linguise, будь ласка, зверніться до адміністратора!"
    },
    "success": {
      "home": "Керувати перекладами домену",
      "message": "Ми прагнемо забезпечити вас найкращим досвідом перекладу. Наша команда експертів готова допомогти вам з будь-якими запитаннями чи підтримкою. Щоб почати, просто натисніть кнопку нижче.",
      "subtitle": "Дякуємо за вибір служби перекладу Linguise",
      "title": "Підписку активовано!",
      "tab_title": "Дякуємо за підписку!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Підписку активовано!",
      "title": "Підписку активовано!",
      "subtitle": "Дякуємо за вибір служби перекладу Linguise",
      "message": "Ми прагнемо забезпечити вас найкращим досвідом перекладу. Наша команда експертів готова допомогти вам з будь-якими запитаннями чи підтримкою. Щоб почати, просто натисніть кнопку нижче.",
      "home": "Керувати перекладами домену"
    },
    "edit": {
      "title": "Керувати підпискою"
    },
    "list": {
      "title": "Список підписок",
      "description": "Список підписок вашого домену"
    },
    "table": {
      "domain": "Домен",
      "plan": "Тариф",
      "status": "Статус",
      "card": "Картка",
      "usage": "Використання",
      "actions": "Дії",
      "payment_method": "Спосіб оплати"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} слів",
      "paidOffered": "{{words_used}} / {{words_allowed}} слів\n(включно {{free_words}} безкоштовних слів)"
    },
    "popup": {
      "dueToday": "Усього до сплати сьогодні",
      "nextPeriod": "Починаючи з {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Виберіть акаунт"
    }
  },
  "translation": {
    "main": {
      "parent": "Переклади",
      "edit": "Редагувати переклад"
    },
    "form": {
      "original": {
        "title": "Оригінал {{language}}"
      },
      "is_inline": "Цей переклад зроблено з вбудованого вмісту.",
      "inline_editor": {
        "count_warning": "Кількість вбудованих областей не збігається з оригіналом ({{current}} із {{expected}}).",
        "restore_original": "Відновити початковий текст",
        "insert_placeholder": "Вставити заповнювач",
        "drag": "Перетягніть, щоб змінити порядок області",
        "area": "Вбудована ділянка {{index}}",
        "restore": "Відновити відсутні вбудовані області"
      },
      "translation": {
        "title": "Переклад {{language}}",
        "description": "Переклад, який ви хочете перевизначити"
      }
    },
    "copy": {
      "title": "Скопіювати в ручний переклад",
      "label": "Копіювати в ручний"
    },
    "level": {
      "base": {
        "title": "Базовий переклад",
        "subtitle": "Автоматичний · переклад Linguise Cloud",
        "empty": "Для цього тексту немає базового перекладу.",
        "overridden": "Ваш вибір збережено, але натомість показується найновіший покращений AI-переклад, бо в налаштуваннях AI-перекладу параметр «Перезаписувати ручні та вибрані переклади» має значення «Так». Вимкніть цей параметр, щоб використати ваш вибір."
      },
      "not_generated": "Не згенеровано",
      "none": "Поки нічого",
      "ai": {
        "title": "Покращений AI-переклад",
        "subtitle": "Автоматичний · Linguise AI",
        "empty_title": "Для цього тексту ще не згенеровано",
        "empty_description": "Linguise AI створює природніші переклади з урахуванням контексту вашої сторінки та сайту. Щоб отримати його тут:",
        "empty_step_1": "Перейдіть до AI-переклад › Налаштування та встановіть для параметра «Увімкнути AI-переклад» значення «Лише правила», «Лише live-редактор» або «Правила й live-редактор».",
        "empty_step_2": "Застосуйте його правилом, що підходить до цієї сторінки, або увімкніть для окремої сторінки в live-редакторі.",
        "empty_step_3": "Покращений AI-переклад з’явиться тут після генерації. Він використовує ваші AI-кредити.",
        "open_settings": "Відкрити налаштування AI-перекладу",
        "open_editor": "Відкрити live-редактор",
        "overrides_selection": "Ваш вибір збережено, але натомість показується цей покращений AI-переклад, бо в налаштуваннях AI-перекладу параметр «Перезаписувати ручні та вибрані переклади» має значення «Так». Вимкніть цей параметр, щоб використати ваш вибір.",
        "overrides_version": "Вибрану вами версію збережено, але натомість показується найновіша покращена AI-версія, бо в налаштуваннях AI-перекладу параметр «Перезаписувати ручні та вибрані переклади» має значення «Так». Вимкніть цей параметр, щоб використати вибрану версію."
      },
      "manual": {
        "title": "Ручний переклад",
        "subtitle": "Ваш власний · має пріоритет над автоматичними перекладами",
        "empty": "Порожньо",
        "saved_but_overridden": "Збережено як ваш вибір, але не показується автоматично, бо в налаштуваннях AI-перекладу параметр «Перезаписувати ручні переклади» має значення «Так»: покращений AI-переклад має перевагу, доки цей параметр не буде вимкнено.",
        "ignored": "Не показується автоматично, бо в налаштуваннях AI-перекладу параметр «Перезаписувати ручні переклади» має значення «Так». Виберіть його, щоб використати для цього тексту.",
        "label": "Ваш переклад",
        "placeholder": "Введіть власний переклад...",
        "last_updated": "Востаннє змінено {{date}}",
        "save_hint": "Збереження ручного перекладу робить його активним.",
        "delete": "Видалити ручний переклад",
        "delete_confirm": "Підтвердьте видалення ручного перекладу"
      }
    },
    "history": {
      "title": "Покращені AI-версії",
      "subtitle": "Кожна повторна генерація з live-редактора зберігається",
      "unknown_model": "Невідома модель",
      "current": "Поточна",
      "restore": "Відновити цю версію",
      "restore_note": "Відновлена версія стає поточним покращеним AI-перекладом. Нічого не видаляється.",
      "version_of": "Версія {{current}} з {{total}}",
      "hide": "Сховати історію ({{total}})",
      "show": "Показати історію ({{total}})"
    },
    "choose": {
      "title": "Переклади мовою: {{language}} · оберіть той, що бачать відвідувачі",
      "current": "Зараз на вашому сайті:",
      "priority": "Пріоритет за замовчуванням: ручний › покращений AI › базовий. Ваш вибір зберігається лише для цього перекладу.",
      "reset": "Повернути пріоритет за замовчуванням",
      "reset_title": "Забути ваш вибір для цього тексту й знову використовувати пріоритет за замовчуванням",
      "resetting": "Скидання…"
    }
  },
  "translations": {
    "title": "Керування перекладами",
    "description": "Список та редагування всіх перекладів вашого сайту; для візуального перекладу використовуйте Live Editor",
    "filter_languages": "Фільтрувати за мовами...",
    "filter_original": "Фільтрувати за текстом оригіналу",
    "filter_translation": "Фільтрувати за перекладеним текстом",
    "table": {
      "original": "Оригінал",
      "language": "Мова",
      "action": "Дія",
      "base": "Базовий",
      "ai": "Покращений AI",
      "manual": "Ручний"
    },
    "filter_exact": "Точне співпадіння",
    "badge": {
      "active": "Активний",
      "overrides_manual": "Замінює ручний"
    },
    "cell": {
      "none": "немає",
      "not_generated": "не згенеровано",
      "ignored": "Ігнорується – перемагає AI-правило"
    },
    "tabs": {
      "all": "Усі",
      "manual": "З ручним",
      "ai": "З покращеним AI",
      "base": "Лише базові"
    },
    "levels_hint": "Кожен текст має до 3 рівнів — той, що позначено «Активний», бачать відвідувачі."
  },
  "url": {
    "main": {
      "parent": "URL",
      "edit": "Редагувати переклад URL"
    },
    "form": {
      "original": {
        "title": "Оригінал {{language}}"
      },
      "translation": {
        "title": "Переклад URL {{language}}",
        "description": "URL, який ви хочете перевизначити",
        "placeholder": "Перевизначення перекладу URL",
        "invalid_full": "Ви намагаєтесь змінити на неправильний формат; слід змінювати лише slugs/pathname перекладу URL",
        "invalid": "Надано неправильний URL/шлях"
      }
    }
  },
  "urls": {
    "title": "Керування URL",
    "description": "Список та редагування всіх перекладів URL вашого сайту (для досвідчених, остерігайтеся помилок 404)",
    "filter_languages": "Фільтрувати за мовами...",
    "filter_original": "Фільтрувати за текстом оригіналу",
    "filter_translation": "Фільтрувати за перекладеним текстом",
    "table": {
      "original": "Оригінал",
      "language": "Мова",
      "url": "Перекладений URL",
      "action": "Дія",
      "edited": "Оригінал перекладу було відредаговано"
    }
  }
}
